<div class="container">
  <h6>{{ 'labels.usedDriving' | translate }}</h6>

  <app-drivers-tachograph
    [primaryDriver]="driver()"
    [secondaryDriver]="null"
    [vehicle]="vehicle()"
    type="vehicle"
    [showHeading]="false"
    [close$]="close$()"
  ></app-drivers-tachograph>
</div>

@if (driver().tachograph; as tachograph) {
  <div class="container">
    <div class="heading">
      <h6>{{ `${I18N}.untilRest` | translate }}</h6>

      @let extensions = tachograph.reducedDailyRestExtensions;
      @if (extensions.remaining; as remaining) {
        <span class="f-muted f-body-m f-medium">
          {{ remaining }}/{{ extensions.limit }}
          {{ `${I18N}.remaining` | translate }}
        </span>
      }
    </div>

    <onyx-information-list>
      <onyx-information-row
        [label]="
          Duration.fromObject({ minutes: 45 })
            | duration: { units: ['m'], plusSign: false }
        "
      >
        @if (nextEstimatedContinuousRestAt(); as rest) {
          {{ rest | onyxDate: 'time-date' }}
        } @else {
          -
        }
      </onyx-information-row>

      <onyx-information-row [label]="`${I18N}.daily`">
        @if (hasOutdatedDailyDrivingData()) {
          -
        } @else {
          {{ tachograph.nextEstimatedDailyRestAt | onyxDate: 'time-date' }}
        }
      </onyx-information-row>

      <onyx-information-row [label]="`${I18N}.weekly`">
        @if (hasOutdatedWeeklyDrivingData()) {
          -
        } @else {
          {{ tachograph.nextEstimatedWeeklyRestAt | onyxDate: 'time-date' }}
        }
      </onyx-information-row>
    </onyx-information-list>
  </div>
}

<app-modal-delegation
  [item]="driver()"
  [close$]="close$()"
  (addDelegation)="addDelegation()"
></app-modal-delegation>

@if (vehicleLoading() || vehicleError()) {
  <app-modal-loading-section
    message="modals.errors.vehicle"
    [loading]="vehicleLoading()"
    [(error)]="vehicleError"
    (errorChange)="reloadVehicle.emit()"
  ></app-modal-loading-section>
} @else {
  <app-modal-vehicles
    [vehicle]="vehicle()"
    [trailer]="vehicle()?.trailer"
    [uuid]="driver().delegation?.uuid ?? null"
    [close$]="close$()"
    [showEdit]="vehicle() != null && order() === null"
    (edit)="assignVehicle()"
  ></app-modal-vehicles>

  @if (vehicle(); as vehicle) {
    <app-modal-order
      [vehicle]="vehicle"
      [order]="order()"
      [loading]="orderLoading()"
      [error]="orderError()"
      [close$]="close$()"
      (reloadOrder)="order$.next()"
    ></app-modal-order>

    <app-modal-swap
      [vehicleUuid]="vehicle.uuid"
      [swapUuid]="driver().relatedFleetSwap?.uuid ?? null"
      [close$]="close$()"
    ></app-modal-swap>
  } @else {
    <app-no-active-order></app-no-active-order>
  }
}
